import { render, staticRenderFns } from "./CalendarItemLocation.vue?vue&type=template&id=47fa99ea"
import script from "./CalendarItemLocation.vue?vue&type=script&lang=js"
export * from "./CalendarItemLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports